import { debounce } from "./utilities.js";
import { stickyVariables } from "./variables.js";
import {functionHandleButtonEvents, handleStickyEvents} from "./stickyHandlers.js";

function stickySectionsJS() {
    const { stickyGroups } = stickyVariables();
    
    if (stickyGroups.length > 0) {
        
        // Set the variable to check if the event Listener has been added
        let isScrollListenerAdded = false;

        functionHandleButtonEvents();
        
        //=====================================================================
        // Intersection Observer function declaration
        //=====================================================================
        const observer = new IntersectionObserver((itemsToObserve) => {
            itemsToObserve.forEach(_item => {
                
                // check all the items to see if intersecting add them to an array and see if any are true
                const anItemIsIntersecting = itemsToObserve.map(items => items.isIntersecting).includes(true);
                
                // Only remove the eventListener if it has already been added
                if (anItemIsIntersecting && !isScrollListenerAdded) {
                    window.addEventListener('scroll', scrollDebounce);
                    isScrollListenerAdded = true;
                } else if (!anItemIsIntersecting && isScrollListenerAdded) {
                    window.removeEventListener('scroll', scrollDebounce);
                    isScrollListenerAdded = false; 
                }
            });
        });
        
        // Call the intersection observer for each sticky group
        stickyGroups.forEach((stickyGroup) => observer.observe(stickyGroup));
        
        // Variable to run debounceFunction if the item is intersecting
        const scrollDebounce = debounce(handleStickyEvents, 25);
        
        // Check the initial variables and trigger event handler on load
        window.addEventListener('load', handleStickyEvents, { once: true });
    }
}

// Self-invoke the function
stickySectionsJS();

// Export the function for potential use in other files
export { stickySectionsJS }; 